import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const OpenInNewSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default OpenInNewSVG;
